var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareTransmit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8571 6.28571C14.5929 6.28571 16 4.87861 16 3.14286C16 1.40711 14.5929 0 12.8571 0C11.1214 0 9.71429 1.40711 9.71429 3.14286C9.71429 3.24518 9.71918 3.34636 9.72873 3.44617L5.26236 5.67936C4.70351 5.16866 3.95956 4.85714 3.14286 4.85714C1.40711 4.85714 0 6.26425 0 8C0 9.73575 1.40711 11.1429 3.14286 11.1429C3.95956 11.1429 4.70351 10.8313 5.26236 10.3206L9.72873 12.5538C9.71918 12.6536 9.71429 12.7548 9.71429 12.8571C9.71429 14.5929 11.1214 16 12.8571 16C14.5929 16 16 14.5929 16 12.8571C16 11.1214 14.5929 9.71429 12.8571 9.71429C11.9434 9.71429 11.1208 10.1042 10.5466 10.7267L6.23408 8.57043C6.26799 8.38544 6.28571 8.19479 6.28571 8C6.28571 7.80521 6.26799 7.61456 6.23408 7.42957L10.5466 5.27332C11.1208 5.89582 11.9434 6.28571 12.8571 6.28571Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareTransmit);
export default __webpack_public_path__ + "static/media/share-transmit.504c825f85a028bbf322c45db0764c89.svg";
export { ForwardRef as ReactComponent };